import HomeContent from "@/pages/home/components/HomeContent";
import { AdvisorProvider } from "@/components/feature/AdvisorProvider";
import { advisors } from "@/mocks/advisors";

export default function FernandoBonilla() {
  return (
    <AdvisorProvider advisor={advisors["fernando-bonilla"]}>
      <HomeContent />
    </AdvisorProvider>
  );
}